// extracted by mini-css-extract-plugin
export default {"side-loader-width":"side-loader-width_ua8fUee_","center-loader-width":"center-loader-width_Apgb5L2y"};